import { z } from 'zod';

/** Main-process updater snapshot, available to new renderers as well as subscribers. */
export const DesktopUpdateStateSchema = z.discriminatedUnion('status', [
  z.object({ status: z.literal('idle'), message: z.string().optional() }),
  z.object({ status: z.literal('checking') }),
  z.object({ status: z.literal('available'), version: z.string().min(1) }),
  z.object({ status: z.literal('downloading'), version: z.string().min(1), progress: z.number().min(0).max(1).optional() }),
  z.object({ status: z.literal('ready'), version: z.string().min(1) }),
  z.object({ status: z.literal('installing'), version: z.string().min(1) }),
  z.object({ status: z.literal('error'), message: z.string(), retry: z.enum(['check', 'download', 'install']), version: z.string().optional() }),
]);
export type DesktopUpdateState = z.infer<typeof DesktopUpdateStateSchema>;
